import React from "react";

// Original Conduit mark: an open aperture "C" routing into a landing node.
export function ConduitMark({ size = 28, color = "currentColor", dot = "#bc6b3c" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
      <path
        d="M22.2 8.6 A 9.4 9.4 0 1 0 22.2 23.4"
        stroke={color}
        strokeWidth="3.1"
        strokeLinecap="round"
      />
      <circle cx="25.6" cy="16" r="2.5" fill={dot} />
    </svg>
  );
}

const chip = (bg) => ({
  width: 26,
  height: 26,
  borderRadius: 6,
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  background: bg,
});

function GoogleWorkspace() {
  return (
    <span style={chip("#ffffff")}>
      <svg width="16" height="16" viewBox="0 0 48 48">
        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
        <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
        <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.28-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
        <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
      </svg>
    </span>
  );
}

function Microsoft365() {
  return (
    <span style={chip("#ffffff")}>
      <svg width="16" height="16" viewBox="0 0 23 23">
        <rect x="1" y="1" width="10" height="10" fill="#F25022" />
        <rect x="12" y="1" width="10" height="10" fill="#7FBA00" />
        <rect x="1" y="12" width="10" height="10" fill="#00A4EF" />
        <rect x="12" y="12" width="10" height="10" fill="#FFB900" />
      </svg>
    </span>
  );
}

function LinkedIn() {
  return (
    <span style={chip("#0A66C2")}>
      <svg width="15" height="15" viewBox="0 0 24 24" fill="#fff">
        <path d="M20.45 20.45h-3.56v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.45v6.29zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.77C.79 0 0 .77 0 1.72v20.56C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z" />
      </svg>
    </span>
  );
}

function Coresignal() {
  return (
    <span style={chip("#10233f")}>
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <rect x="3" y="13" width="3.4" height="7" rx="1.2" fill="#5ea8ff" />
        <rect x="10.3" y="8" width="3.4" height="12" rx="1.2" fill="#8fc2ff" />
        <rect x="17.6" y="4" width="3.4" height="16" rx="1.2" fill="#ffffff" />
      </svg>
    </span>
  );
}

function YCombinator() {
  return (
    <span style={chip("#FB651E")}>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7 6 L12 12.4 L17 6" />
        <path d="M12 12.4 L12 18.5" />
      </svg>
    </span>
  );
}

const MAP = {
  "Google Workspace": GoogleWorkspace,
  "Microsoft 365": Microsoft365,
  LinkedIn: LinkedIn,
  Coresignal: Coresignal,
  "YC directory": YCombinator,
};

export function ChannelLogo({ name }) {
  const Cmp = MAP[name];
  return Cmp ? <Cmp /> : null;
}
